
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#575f68","d":"M295.6 317h-79.2c-53.2 0-95.9 42.1-97 94.6-3.1 15.8-7.3 43.1 3.1 53.6C149.7 491.5 209.1 501 256 501s106.3-9.5 133.4-35.8c10.4-10.5 6.3-37.9 3.1-53.6-1-52.6-43.7-94.6-96.9-94.6zm80.3 132.5C357.1 468.4 311.3 480 257 480s-101.1-11.6-118.9-29.4c-2.1-3.2-1-21 2.1-35.8v-2.1c0-42.1 34.4-75.7 76.1-75.7v-1.1h80.3c41.7 0 76.1 33.6 76.1 75.7v2.1c3.2 14.7 5.3 32.6 3.2 35.8zM256 304.4c43.8 0 78.2-34.7 78.2-77.8s-34.4-77.8-78.2-77.8c-42.7 0-78.2 34.7-78.2 77.8s34.4 77.8 78.2 77.8zm0-135.7c32.3 0 58.4 26.3 58.4 57.8 0 31.5-26.1 57.8-58.4 57.8s-58.4-26.3-58.4-57.8c0-31.5 26.1-57.8 58.4-57.8zM245.6 49.6v79.2h19.8V48.5l22.9 22.4 13.6-13.6L256 11l-45.9 46.3 13.6 13.6zM129.9 216v-19.9H48.8L71.5 174l-14.6-13.7L11 205.5l45.9 46.3 14.6-14.7L49.9 216zm325.2-55.7L440.5 174l22.7 22.1h-81.1V216h80l-21.6 21.1 14.6 14.7 45.9-46.3z"}})])
          )
        }
      }
    